import { createFileRoute } from '@tanstack/react-router'

import { FormPreviewPage } from '@/pages/form-preview'

export const Route = createFileRoute('/_app/workflows/workflows/form/preview/$id')({
  component: RouteComponent,
})

export const FormPreviewRoute = Route

function RouteComponent() {
  const { id } = FormPreviewRoute.useParams()
  return <FormPreviewPage id={id} />
}
